import { createFileRoute } from "@tanstack/react-router";
import { MainView } from "@/pages/MainView";

export const Route = createFileRoute("/")({
  component: HomePage,
});

function HomePage() {
  return <MainView />;
}
